import React from "react";
import { TextField } from "@mui/material";
import { useTheme } from "../../theme/ThemeContext";

const getInputStyles = (theme) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    "& fieldset": {
      borderColor: theme?.divider,
    },
    "&:hover fieldset": {
      borderColor: theme?.app_button_color,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme?.app_button_color,
    },
  },
  "& .MuiInputLabel-root": {
    color: theme?.text_color,
    "&.Mui-focused": {
      color: theme?.app_button_color,
    },
  },
  "& .MuiInputBase-input": {
    color: theme?.text_color,
  },
  "& .MuiFormHelperText-root": {
    color: theme?.text_color,
  },
});

export const Input = ({
  label,
  variant = "outlined",
  size = "medium",
  fullWidth = true,
  error = false,
  helperText,
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  return (
    <TextField
      label={label}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      sx={{
        ...getInputStyles(theme),
        ...sx,
      }}
      {...props}
    />
  );
};

// Specific input variants for common use cases
export const EmailInput = ({ ...props }) => {
  const theme = useTheme();
  return (
    <TextField
      fullWidth
      label="Email"
      type="email"
      name="email"
      autoComplete="email"
      sx={getInputStyles(theme)}
      {...props}
    />
  );
};

export const PasswordInput = ({ ...props }) => {
  const theme = useTheme();
  return (
    <TextField
      fullWidth
      label="Password"
      type="password"
      name="password"
      autoComplete="current-password"
      sx={getInputStyles(theme)}
      {...props}
    />
  );
};

export const NameInput = ({ ...props }) => {
  const theme = useTheme();
  return (
    <TextField
      fullWidth
      label="Name"
      type="text"
      name="name"
      autoComplete="name"
      sx={getInputStyles(theme)}
      {...props}
    />
  );
};

export const PhoneInput = ({ ...props }) => (
  <TextField
    fullWidth
    label="Phone"
    type="tel"
    name="phone"
    autoComplete="tel"
    sx={getInputStyles(useTheme())}
    {...props}
  />
);

export const SearchInput = ({ ...props }) => (
  <Input
    label="Search"
    placeholder="Search products..."
    variant="outlined"
    size="small"
    {...props}
  />
);

export default Input;
